import React, { useEffect, useRef, useState } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import MieszkaniecWydrukA4 from '../../../Mieszkaniec/Wydruk/MieszkaniecWydrukA4.js';
import robotoFont from  "../../../../fonts/Roboto-Regular-normal.js";

const WspolnotaRozliczenieSeryjneMasowa = ( props ) => {

  const { tablicaObiektow, showPrint, stawkiOst, stawkiJednorazowe, lokale, ulice, miesiac, wspolnota } = props;
  
  const divRefs = useRef([]);

  const [activeButton, setActiveButton] = useState(true);

  useEffect( () => setActiveButton(tablicaObiektow?.length > 0 ? false : true), [tablicaObiektow]);

  const [docksList, setDockList] = useState([]);

  const generatePDF = async () => {

    const doc = new jsPDF('p', 'mm', 'a4');
    doc.addFileToVFS("Roboto-Regular.ttf", robotoFont);
    doc.addFont("Roboto-Regular.ttf", "Roboto-Regular", "normal");
    doc.setFont("Roboto-Regular");

    for (let i = 0; i < divRefs.current.length; i++) {
      const { ref } = divRefs.current[i];

      // Wymuszenie białego tła
      ref.style.backgroundColor = 'white';

      // Renderuj canvas
      const canvas = await html2canvas(ref, {
        scale: 2, // dobra jakość, można dać 1.5 jak chcesz mniejszy plik
        backgroundColor: '#ffffff',
        useCORS: true,
      });

      const imgData = canvas.toDataURL('image/jpeg', 0.8); // kompresja JPEG

      const pdfWidth = 210;
      const pdfHeight = 297;
      if (i > 0) doc.addPage();
      doc.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight);
    }

    const fileName = `Wymiar zaliczki - ${wspolnota?.name} - ${miesiac}.pdf`;
    doc.save(fileName);
    
  };

  const generateDocks = () => {
    return new Promise((resolve) =>{
      const wygenerowanyKodHTML = tablicaObiektow?.map((obj, index) => {

        return (
          <div           
            id={`header_${obj.udzialyKonta_a.id}`}
            ref={(el) => (divRefs.current[index] = {ref: el, refNr: obj.udzialyKonta_a.id})}
            key={index}
            className={`previewDock n_${obj.nota}`}
            style={{marginBottom: "10px"}}
          >
            <MieszkaniecWydrukA4
              udzialyKonta_a={obj.udzialyKonta_a}
              mieszkaniec={obj.mieszkaniec}
              tablicaCzynszeAkt={obj.tablicaCzynszeAkt}
              stawkiOst={stawkiOst}
              stawkiJednorazowe={stawkiJednorazowe}
              stawkiJednorazoweInd={obj.jednorazoweInd}
              lokale={lokale}
              ulice={ulice}
              grupy_a={obj.grupy_a}
              miesiac={miesiac}
              grupa_numer={obj.grupa_numer}
              wybraneRozliczenieWody={obj.wybraneRozliczenieWody}
            />
          </div>
        )
        
      });
      setDockList(wygenerowanyKodHTML);
      resolve();
    })
  } 

  const onClick = () => {
    generateDocks() 

  }
  
  return (
    <div>
      {/* Dynamicznie generowane komponenty na podstawie tablicy obiektów */}
      <button
        onClick={onClick}
        disabled={activeButton}
      >
        1. Wygeneruj podgląd
      </button>
      <button 
        onClick={generatePDF}
        disabled={activeButton}
      >
        2. Generuj pdf-y i zapisz
      </button>
      <div 
        id="docks"
        
      >
        {docksList}
      </div>
    </div>
  );
};

export default WspolnotaRozliczenieSeryjneMasowa;